export default function ($translate) {
    return {
        KEYS: {
            BEFORE_TRAINING_DEADLINE: 'BEFORE_TRAINING_DEADLINE',
            BEFORE_TRAINING_START: 'BEFORE_TRAINING_START'
        },
        LABELS: {
            BEFORE_TRAINING_DEADLINE: $translate.instant('events.Before training deadline'),
            BEFORE_TRAINING_START: $translate.instant('events.Before training start')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingTimeType/index.js